// extracted by mini-css-extract-plugin
export var layoutContainer = "_59-0";
export var layoutContainerOpen = "_59-5";
export var layoutContainerResizing = "_59-1";
export var mainContent = "_59-2";
export var resizeDivider = "_59-3";
export var slidePanel = "_59-4";